import Lottie from 'lottie-react-web';
import React from 'react';
import { castingError } from 'src/common/utils/ErrorHandler';
import { Container, LoadingView, RegularText } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';

export const EmptyState = ({ loading, error, text }: { loading: boolean; error: any; text: string }) => {
  if (loading) return <LoadingView />;
  if (error) return <ErrorContent text={castingError(error)} />;
  return <EmptyContent text={text} />;
};

const EmptyContent = ({ text }: { text: string }) => {
  return (
    <Container marginTop={metrics.extraHuge}>
      <Lottie
        height={pixelScaler(81)}
        width={pixelScaler(185)}
        options={{
          loop: false,
          animationData: require('src/assets/lotties/empty.json'),
        }}
      />
      <Container marginTop={metrics.large} paddingHorizontal={metrics.medium}>
        <RegularText textAlign="center" color={AppColors.gray} textLang={text} />
      </Container>
    </Container>
  );
};

const ErrorContent = ({ text }: { text: string }) => {
  return (
    <Container marginTop={metrics.large}>
      <Lottie
        height={pixelScaler(140)}
        width={pixelScaler(140)}
        options={{
          loop: false,
          animationData: require('src/assets/lotties/system-error.json'),
        }}
      />
      <Container paddingHorizontal={metrics.medium}>
        <RegularText textAlign="center" fontWeight="bold" fontSize="huge" textLang="somethingWentWrong" />
        <Container height={metrics.small} />
        <RegularText fontSize="large" textAlign="center" color={AppColors.gray} textLang={text} />
      </Container>
    </Container>
  );
};
